export const socials = [
  {
    href: "https://discord.gg/9sUDHyGQfC",
    name: "Discord",
    description: "FlyawayBear#7787",
    logo: <i className="fa-brands fa-discord fa-2x"></i>
  },
  {
    href: "https://github.com/flyawaybear",
    name: "GitHub",
    description: "FlyawayBear",
    logo: <i className="fa-brands fa-github fa-2x"></i>
  },
  {
    href: "https://www.youtube.com/channel/UCLoeX78R9HM5ogCteGACQqg",
    name: "YouTube",
    description: "FlyawayBear",
    logo: <i className="fa-brands fa-youtube fa-2x"></i>
  },
  {
    href: "https://twitch.tv/flyawaybear",
    name: "Twitch",
    description: "FlyawayBear",
    logo: <i className="fa-brands fa-twitch fa-2x"></i>
  },
];
